import { useEffect } from 'react'

import { EVENT_WYSIWYG_FOCUS } from '../../constants/event'

export function useSelectGlobalClose({ setOpen }) {
  useEffect(() => {
    function handleGlobalClose() {
      setOpen(false)
    }

    document.addEventListener(EVENT_WYSIWYG_FOCUS, handleGlobalClose)

    return () => {
      document.removeEventListener(EVENT_WYSIWYG_FOCUS, handleGlobalClose)
    }
  }, [])
}
